import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { Cluster, XYZ, Vector as VectorSource } from 'ol/source';
import { Fill, Circle as CircleStyle, Style, Stroke, Text } from 'ol/style';
import { fromLonLat, toLonLat } from 'ol/proj';
import { LineString } from 'ol/geom';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import { defaults, MousePosition } from 'ol/control';
import { createStringXY } from 'ol/coordinate';
import axios from 'axios';
// import iconMap from './components/map';
import successIcon from '@/assets/images/green-pin.png';
import warningIcon from '@/assets/images/yellow-pin.png';
import dangerIcon from '@/assets/images/red-pin.png';
// import coordtransform from 'coordtransform'; // gps坐标转gcj02
import Point from 'ol/geom/Point';
import {
  Select,
  defaults as defaultInteractions,
} from 'ol/interaction';
// import Zoom from 'ol/control/Zoom';

export default class MapService {
  constructor(
    containerId,
    { showControl } = { showControl: false },
  ) {
    this.containerId = containerId;
    this.startCenter = [116, 39];
    this.startZoom = 3;
    this.minZoom = 1;
    this.maxZoom = 18;
    this.mapInstance = null;
    // 是否显示控制内容
    this.showControl = showControl;
    // 视图
    this.view = null;
    // 标记物单例弹窗 dom
    this.infoWindow = null;
    // 记录mark
    this.markers = [];
    this.features = [];
    this.clusters = null;
    this.tileLayer = [];
  }

  /**
   * 解析返回事件的经纬度
   */
  static parseLngLatFromEvent(e) {
    const [lng, lat] = e.coordinate;
    const [mapLng, mapLat] = toLonLat([lng, lat]); // 转回gps坐标
    return { lng: mapLng.toFixed(5), lat: mapLat.toFixed(5) };
  }

  setSource(type) {
    // 遥感图
    let data = {
      map: 'https://t0.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
      text: 'https://t0.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
    };
    switch (type) {
      case 'p': { // 地形图
        data = {
          map: 'https://t0.tianditu.gov.cn/DataServer?T=ter_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
          text: 'https://t0.tianditu.gov.cn/DataServer?T=cta_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
        };
        break;
      }
      case 'm': { // 交通图
        data = {
          map: 'https://t0.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
          text: 'https://t0.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
        };
        break;
      }
      default:
        break;
    }
    const tileLayer = new TileLayer({
      name: 'titleLayer',
      source: new XYZ({
        crossOrigin: 'anonymous',
        urls: [
          data.map,
        ],
      }),
    });
    const tileLayer2 = new TileLayer({
      name: 'titleLayer',
      source: new XYZ({
        urls: [
          data.text,
        ],
      }),
    });
    this.tileLayer.map((item) => {
      this.mapInstance.removeLayer(item);
      return item;
    });
    this.mapInstance.addLayer(tileLayer);
    this.mapInstance.addLayer(tileLayer2);
    this.tileLayer = [tileLayer, tileLayer2];
  }

  initMap(cb) {
    const tileLayer = new TileLayer({
      name: 'titleLayer',
      source: new XYZ({
        crossOrigin: 'anonymous',
        urls: [
          'https://t0.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
        ],
        // urls: [
        // 'http://webst0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}',
        // lyrs=s为地图类型，m路线图 t地形图 p带标签的地形图 s卫星图 y带标签的卫星图 h标签层
        // 'https://mt0.google.cn/vt/lyrs=y&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=',
        // 'https://mt1.google.cn/vt/lyrs=y&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=',
        // 'https://mt2.google.cn/vt/lyrs=y&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=',
        // 'https://mt3.google.cn/vt/lyrs=y&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=',
        // ],
      }),
    });

    // 影像注记
    const tileLayer2 = new TileLayer({
      name: 'titleLayer',
      source: new XYZ({
        urls: [
          'https://t0.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=335858900df6512ae00fba47fe3bc8fb',
        ],
      }),
    });

    this.tileLayer = [tileLayer, tileLayer2];

    this.view = new View({
      center: fromLonLat(this.startCenter),
      zoom: this.startZoom,
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
    });

    const thisTemp = this;

    // 实例化map
    const mapInstance = new Map({
      target: this.containerId,
      layers: this.tileLayer,
      view: this.view,
      controls: defaults({
        zoomOptions: {
          className: 'hs-zoom',
        },
      }),
      interactions: defaultInteractions().extend([
        new Select({
          condition(evt) {
            return evt.type === 'dblclick' || evt.type === 'singleclick';
          },
          style: (feature) => {
            const originalFeatures = feature.get('features');
            // eslint-disable-next-line no-underscore-dangle
            const coordinate = originalFeatures[0].values_.options.position;
            // eslint-disable-next-line no-underscore-dangle
            thisTemp.view.setCenter(coordinate);
            thisTemp.setZoom(20);
          },
        })]),
    });
    // 是否显示控制器
    if (this.showControl) {
      // 坐标
      mapInstance.addControl(
        new MousePosition({
          coordinateFormat: createStringXY(4),
          projection: 'EPSG:4326',
          className: 'mousePosition controlsCommon',
          target: document.getElementById('mouse-position'),
          // 设置移出之后坐标依然显示
          undefinedHTML: false,
        }),
      );
    } else {
      // eslint-disable-next-line no-underscore-dangle
      mapInstance.removeControl(mapInstance.getControls().array_[0]);
    }

    this.mapInstance = mapInstance;

    // 添加信息窗口overlay
    const infoWindow = document.createElement('div');
    infoWindow.id = 'hsol-info-window';
    this.infoWindow = new Overlay({
      element: infoWindow,
      positioning: 'bottom-center',
      stopEvent: true,
      offset: [0, -60],
    });
    this.mapInstance.addOverlay(this.infoWindow);

    // eslint-disable-next-line func-names
    this.mapInstance.on('pointermove', function (evt) {
      const hit = this.forEachFeatureAtPixel(evt.pixel, () => {
        return true;
      });
      if (hit) {
        this.getTargetElement().style.cursor = 'pointer';
      } else {
        this.getTargetElement().style.cursor = '';
      }
    });

    // 监听map的缩放
    // this.mapInstance.on('moveend', () => {
    //   console.log('zoom', this.mapInstance.getView().getZoom());
    // });

    if (cb) cb();
  }

  /**
   * 更新地图的伸缩
   */
  setZoom(level) {
    if (this.mapInstance) {
      this.view.animate({ zoom: level, duration: 3000 });
    }
  }

  /**
   * 地图坐标适配方法
   */
  // eslint-disable-next-line class-methods-use-this
  wrapPosition(position) {
    if (Array.isArray(position)) {
      return fromLonLat(position);
    }
    const { lng, lat } = position;
    return fromLonLat([lng, lat]);
  }

  /**
   * 更新地图中心--添加了动画的移动到中心点
   */
  setCenter(position, interval = 1000) {
    if (this.mapInstance) {
      const coordinate = this.wrapPosition(position);
      this.view.animate({
        center: coordinate,
        duration: interval,
      });
    }
  }

  setCenterNormal(position) {
    if (this.mapInstance) {
      const coordinate = this.wrapPosition(position);
      this.view.setCenter(coordinate);
    }
  }

  /**
   * 飞行到最后添加的标记物
   */
  flyToLastMarker() {
    // 飞行到最后添加的
    // const lastMarker = this.markers[this.markers.length - 1];
    // 飞行到第一个添加的
    const lastMarker = this.markers[0];
    if (lastMarker) {
      // 根据标记物类型确定缩放等级
      const markerType = lastMarker.get('options').type;
      let zoom = 0;
      switch (markerType) {
        case 'PROJECT': zoom = 5; break;
        case 'STRUCTURE': zoom = 8; break;
        case 'MEASURING_POINT': zoom = 18; break;
        default:
          if (typeof markerType === 'number')zoom = markerType;
      }
      this.view.animate({
        center: lastMarker.getPosition(),
        duration: 2000,
      });
      this.view.animate({
        zoom,
        duration: 3000,
      });
    }
  }

  /**
   * 添加简单标记物
   */
  addSimpleMarker({
    lat,
    lng,
    id = new Date().getTime(),
    type,
    status = 'success',
  }) {
    const coordinate = fromLonLat([lng, lat]);
    const marker = new Overlay({
      position: coordinate,
      positioning: 'bottom-center',
      element: this.createSimpleMarkerElement(status),
      stopEvent: true,
    });
    marker.set('options', {
      id, type,
    });
    this.mapInstance.addOverlay(marker);
    this.markers.push(marker);

    return marker;
  }

  // eslint-disable-next-line class-methods-use-this
  createSimpleMarkerElement(status = 'success') {
    const dom = document.createElement('div');
    dom.className = 'hs-simple-marker';
    const icons = {
      danger: dangerIcon,
      success: successIcon,
      warning: warningIcon,
    };
    dom.innerHTML = `
    <div>
      <img src="${icons[status]}" class="hs-simple-marker__img"></img>
    </div>
    `;
    return dom;
  }

  addOverlay({
    id, name, type, dom, lng, lat, vm, state, level,
  }) {
    // 天地图使用的是CGCS2000和WGS84相差不大。
    // 天地图GCJ02 转换为 WGS84使用gcj02towgs84(),谷歌地图WGS84转GCj02使用wgs84togcj02（）
    const coordinate = fromLonLat([lng, lat]);
    const marker = new Overlay({
      position: coordinate,
      positioning: 'bottom-center',
      element: dom,
      stopEvent: true,
    });
    const feature = new Feature(new Point(coordinate));
    feature.setId(id);
    feature.set('options', { position: coordinate });
    this.features.push(feature);
    marker.set('options', { id, name, type, state, vm, level });
    this.mapInstance.addOverlay(marker);
    this.markers.push(marker);
    return marker;
  }

  addClusters() {
    const source = new VectorSource({
      features: this.features,
    });
    const clusterSource = new Cluster({
      distance: 20,
      source,
    });

    const thisTemp = this;

    this.clusters = new VectorLayer({
      source: clusterSource,
      style(feature) {
        const features = feature.get('features');
        const size = features.length;
        if (size > 1) {
          let markerState = 0;
          features.forEach((item) => {
            // eslint-disable-next-line no-underscore-dangle
            const marker = thisTemp.showMarker(item.id_, false);

            // eslint-disable-next-line no-underscore-dangle
            markerState = markerState >= marker.values_.options.level ? markerState : marker.values_.options.level;
          });
          return new Style({
            image: new CircleStyle({
              radius: thisTemp.setClusterRadius(size),
              stroke: new Stroke({
                color: 'rgba(255,255,255,0.4)',
              }),
              fill: new Fill({
                color: thisTemp.setFillColor(markerState),
              }),
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: '#fff',
              }),
            }),
          });
        }
        // eslint-disable-next-line no-underscore-dangle
        thisTemp.showMarker(features[0].id_, true);
        return null;
      },
    });
    this.mapInstance.addLayer(this.clusters);
  }

  /**
   * @description 设置cluster的样式
   * @param {number} level marker的level
   * @memberof MapService
   */
  // eslint-disable-next-line class-methods-use-this
  setFillColor(level) {
    let color = '#ED4C33';
    switch (level) {
      case 0:
        color = '#29B359'; // 正常状态 绿色
        break;
      case 1:
        color = '#EDC733'; // 一级警告 黄色
        break;
      case 2:
        color = '#ED8533'; // 二级警告 橙色
        break;
      case 3:
        color = '#ED4C33'; // 三级警告 红色
        break;
      default:
        color = '#ED4C33'; // 三级警告 红色
    }
    return color;
  }

  // eslint-disable-next-line class-methods-use-this
  setClusterRadius(size) {
    if (size > 1 && size <= 10) {
      return 30;
    }
    if (size > 10 && size <= 100) {
      return 40;
    }
    if (size > 100) {
      return 50;
    }
    return 30;
  }

  /**
   * @description 是否展示标记物
   * @param {string || number} id marker的id
   * @param {Boolean} type marker是否展示
   * @memberof MapService
   */
  showMarker(id, type) {
    const marker = this.findMarkerOrError(id);
    marker.element.hidden = type ? false : 'hidden';
    return marker;
  }

  /**
   * @description 删除标记物
   * @param {string || number} id markder的id
   * @memberof MapService
   */
  deleteMarker(id) {
    const marker = this.findMarkerOrError(id);
    this.mapInstance.removeOverlay(marker);
  }

  /**
   * 更新标记物坐标
   */
  updateMarker({ id, position }) {
    const marker = this.findMarkerOrError(id);
    const coordinate = this.wrapPosition(position);
    marker.setPosition(coordinate);
  }

  /**
   * 清空标记物
   */
  clearMarkers() {
    this.features = [];
    this.mapInstance.removeLayer(this.clusters);
    this.markers.forEach((marker) => {
      this.mapInstance.removeOverlay(marker);
    });
    this.markers = [];
  }

  // 查看标点是否存在
  findMarkerOrError(markerId) {
    const marker = this.findMarker(markerId);
    if (!marker) throw new Error('找不到标记点');
    return marker;
  }

  // 找到标点的对象
  findMarker(markerId) {
    return this.markers.find(m => m.get('options').id === markerId);
  }

  // 设置弹窗的样式
  setInfoWindowContent(content) {
    if (typeof content === 'string') {
      this.infoWindow.getElement().innerHTML = content;
    } else {
      this.infoWindow.getElement().innerHTML = '';
      this.infoWindow.getElement().appendChild(content);
    }
  }

  openInfoWindow(marker) {
    // const coordinate = fromLonLat([lng, lat]);
    this.infoWindow.setPosition(marker.getPosition());
    this.infoWindow.getElement().style.display = 'block';
  }

  // 打开弹窗 - dom优化获取
  openMarkerInfoWindow(id) {
    const marker = this.findMarkerOrError(id);
    this.openInfoWindow(marker);
  }

  // 关闭弹窗 -dom 优化获取
  closeInfoWindow() {
    this.infoWindow.getElement().style.display = 'none';
  }

  // 添加事件监听--只能监听mapInstance对象中的内容来实现不同图层的各种事件的监听
  addListenerToMarker(event, listener) {
    if (typeof listener !== 'function') {
      throw new Error('标记点事件监听器参数错误');
    }

    switch (event) {
      case 'mouseover':
        this.mapInstance.on('pointermove', (e) => {
          if (this.mapInstance.hasFeatureAtPixel(e.pixel)) {
            const pixel = this.mapInstance.getEventPixel(e.originalEvent);
            this.mapInstance.forEachFeatureAtPixel(pixel, (feature) => {
              if (feature) {
                // eslint-disable-next-line no-underscore-dangle
                listener(feature.values_.name, e);
              }
            });
          }
        });
        break;
      case 'mouseout':
        this.mapInstance.on('pointermove', (e) => {
          if (!this.mapInstance.hasFeatureAtPixel(e.pixel)) {
            listener(e);
          }
        });
        break;
      case 'click':
        // 会有250ms延迟以确保不是双击
        this.mapInstance.on('singleclick', (e) => {
          const pixel = this.mapInstance.getEventPixel(e.originalEvent);
          this.mapInstance.forEachFeatureAtPixel(pixel, (feature) => {
            if (feature) {
              // eslint-disable-next-line no-underscore-dangle
              const marker = this.findMarkerOrError(feature.values_.name);
              listener(marker, e);
            }
          });
        });
        break;
      default:
        throw new Error('标记点监听事件错误');
    }
  }

  // 地图的监听事件
  addListenerToMap(event, listener) {
    if (typeof listener !== 'function') {
      throw new Error('地图事件监听器参数错误');
    }

    const mapInstance = this.mapInstance;
    if (!mapInstance) {
      throw new Error('地图未初始化');
    }

    switch (event) {
      case 'click':
        this.mapInstance.on('singleclick', (e) => {
          listener(e);
        });
        break;
      default:
        throw new Error('标记点监听事件错误');
    }
  }

  // 强制重新计算地图视口大小。
  updateSize() {
    // 延时修改map的大小
    setTimeout(() => {
      this.mapInstance.updateSize();
    }, 1000);
  }

  // eslint-disable-next-line class-methods-use-this
  placeSearch(keyword, cb) {
    axios({
      url: 'http://api.tianditu.gov.cn/search',
      params: {
        postStr: {
          keyWord: keyword,
          level: '15',
          mapBound: '-180,-90,180,90',
          queryType: '4',
          count: '20',
          start: '0',
        },
        type: keyword,
        tk: '335858900df6512ae00fba47fe3bc8fb',
      },
      method: 'get',
    }).then((rs) => {
      if (cb) cb(rs.data);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  getLocationPosition(address, cb) {
    axios({
      url: 'http://api.tianditu.gov.cn/geocoder',
      params: {
        ds: {
          keyWord: address,
        },
        tk: '335858900df6512ae00fba47fe3bc8fb',
      },
      method: 'get',
    }).then((rs) => {
      if (cb) {
        const { location } = rs.data;
        const forPositon = { lat: location.lat, lng: location.lon };
        cb(forPositon);
      }
    });
  }

  // 绘制轨迹
  // eslint-disable-next-line class-methods-use-this
  initPolyline(markers, borderWidth = 2) {
    const coordinatesPolygon = [];
    markers.forEach((item) => {
      const pointTransform = fromLonLat([item.lng, item.lat]);// 转gcj02坐标 再转平面坐标
      coordinatesPolygon.push(pointTransform);
    });

    const vectorSource = new VectorSource({ wrapX: false });
    const vectorLine = new VectorLayer({
      source: vectorSource,
      style: new Style({
        stroke: new Stroke({// 地图连线的样式
          color: '#409EFF', // 颜色
          width: borderWidth, // 宽度
        }),
      }),
    });
    const lineString = new LineString(coordinatesPolygon);

    const feature = new Feature({
      geometry: lineString,
    });

    vectorSource.addFeature(feature);
    this.mapInstance.addLayer(vectorLine);
    this.vectorLayer = vectorLine; // 矢量图层更新使用
  }

  // 更新轨迹
  // eslint-disable-next-line class-methods-use-this
  updatePolyline(markers) {
    if (!this.vectorLayer) return;
    const coordinatesPolygon = [];
    markers.forEach((item) => {
      const pointTransform = fromLonLat([item.lng, item.lat]); // 转gcj02坐标 再转平面坐标
      coordinatesPolygon.push(pointTransform);
    });

    const vectorSource = new VectorSource({ wrapX: false });
    const lineString = new LineString(coordinatesPolygon);
    const feature = new Feature({
      geometry: lineString,
    });

    vectorSource.addFeature(feature);
    this.vectorLayer.setSource(vectorSource);
  }
}
